// Slick JS for Video Gallery component

$(function() {
    if($('.video-gallery-slider').length > 0) {
        $('.video-gallery-slider').each(function(){
            var $slider = $(this)

            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 641,
                        settings: {
                            arrows: false,
                            dots: true
                        }
                    }
                ]
            });
        })
    }
});

// Matching Element Height
$(window).on('load', function(){
    function setHeight(elementH) {
        var maxH = 0;
        var len = $(elementH).length;
        $(elementH).css('min-height', '');

        $(elementH).each(function (index) {
            var curH = $(this).outerHeight();
            if (curH > maxH) {
                maxH = curH;
            }

            if ((index + 1) == len) {
                $(elementH).css({ 'min-height': maxH });
            }
        });
    }

    setHeight('.video-gallery-slider .video-wrap'); // Slide
});